module.exports = __webpack_public_path__ + "static/media/quiz-hint-3-video-thumbnail.b2cb5b3e.jpg";